import { useState } from 'react';

// The signup logic is shared with the existing guide form instead of remaining unbound.
export const useEmailSignup = ({ name, onSuccess }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleEmailSubmit = async (event) => {
    event.preventDefault();
    if (loading) return;
    const trimmedEmail = email.trim().toLowerCase();
    if (!trimmedEmail || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimmedEmail)) {
      setError('Please enter a valid email address');
      return;
    }
    setError('');
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/waitlist/join`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email: trimmedEmail }),
      });
      const data = await response.json();
      if (response.ok && data.success) {
        onSuccess(data);
        setEmail('');
      } else {
        setError(data.message || 'Something went wrong. Try again!');
      }
    } catch {
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return { email, setEmail, loading, error, handleEmailSubmit };
};